import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Drawer from 'rc-drawer';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { Button } from 'reactstrap';
import InitiativeDetail from 'components/Agile/initiative/initiativeDetail';
import InitiativeTable from 'components/Agile/initiative/initiativeTable';
import InitiativeAdd from 'components/Agile/initiative/initiativeMaintenance/initiativeAdd';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress';
import CustomScrollbars from 'util/CustomScrollbars';
import {
    fetchInitiatives,
    handleInitiativeRequestClose,
    showInitiativeLoader,
    onAddInitiative,
    onToggleInitiativeDrawer,
} from 'actions/initiative';
import {
    fetchProducts,
} from 'actions/product';

const Component = () => {
    const dispatch = useDispatch();

    const width = useSelector(state => state.settings.width);
    const loader = useSelector(state => state.initiatives.loader);
    const alertMessage = useSelector(state => state.initiatives.alertMessage);
    const showMessage = useSelector(state => state.initiatives.showMessage);
    const noContentFoundMessage = useSelector(state => state.initiatives.noContentFoundMessage);
    const drawerState = useSelector(state => state.initiatives.drawerState);
    const initiative = useSelector(state => state.initiatives.initiative);
    const initiativeList = useSelector(state => state.initiatives.initiativeList);

    useEffect(() => {
        dispatch(showInitiativeLoader());
        dispatch(fetchInitiatives());
        dispatch(fetchProducts());
    }, []);

    const initiativeSideBar = () => {
        return <div className="module-side">
            <div className="module-side-header">
                <div className="module-logo">
                    <i className="zmdi zmdi-city-alt mr-4" />
                    <span><IntlMessages id="sidebar.initiatives" /></span>
                </div>
            </div>

            <div className="module-side-content">
                <CustomScrollbars className="module-side-scroll scrollbar"
                    style={{ height: width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)' }}>
                    <div className="module-add-task">
                        <Button className="btn-block jr-btn" color="primary"
                            onClick={() => dispatch(onAddInitiative())}>
                            <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                            <span><IntlMessages id="initiative.addInitiative" /></span>
                        </Button>
                    </div>
                </CustomScrollbars>
            </div>
        </div>;
    };

    const initiativeRequestClose = () => {
        dispatch(handleInitiativeRequestClose());
    };

    return (
        <div className="app-wrapper">
            <div className="app-module animated slideInUpTiny animation-duration-3">
                <div className="d-block d-xl-none">
                    <Drawer
                        touch={true}
                        transitions={true}
                        enableDragHandle={true}
                        open={drawerState}
                        onOpenChange={() => dispatch(onToggleInitiativeDrawer())}
                        sidebar={initiativeSideBar(initiative)} />
                </div>
                <div className="app-module-sidenav d-none d-xl-flex">
                    {initiativeSideBar(initiative)}
                </div>
                <div className="module-box">
                    <div className="module-box-content">
                        <div className="module-box-header">
                            <span className="icon-btn drawer-btn d-flex d-xl-none"
                                onClick={() => dispatch(onToggleInitiativeDrawer())}>
                                <i className="zmdi zmdi-menu" />
                            </span>
                        </div>
                        <CustomScrollbars className="module-list-scroll scrollbar"
                            style={{ height: width >= 1200 ? 'calc(108vh - 265px)' : 'calc(108vh - 245px)' }}>
                            {loader ?
                                <div
                                    className="loader-view-block h-100">
                                    <div className="loader-view">
                                        <CircularProgress />
                                    </div>
                                </div>
                                :
                                initiativeList && initiativeList.length > 0 ?
                                    <Fragment>
                                        <div className="app-main-content">
                                            <InitiativeTable />
                                            <div style={{ marginTop: 10 }}>
                                                <InitiativeDetail />
                                            </div>
                                        </div>
                                    </Fragment>
                                    :
                                    <div className="h-100 d-flex align-items-center justify-content-center">
                                        {noContentFoundMessage}
                                    </div>
                            }
                        </CustomScrollbars>

                    </div>
                </div>
            </div>
            <InitiativeAdd />

            {showMessage && NotificationManager.success(alertMessage, initiativeRequestClose())}
            <NotificationContainer />

        </div>
    );
};

export default Component;



// WEBPACK FOOTER //
// ./components/Agile/initiative/component.js